import moment from 'moment';
var getDiffDays = function (startDate, endDate) {
    return Math.abs(moment.duration(moment(startDate).diff(moment(endDate))).asDays());
};
var getTimeRangeForCustomDate = function (startDate, endDate) {
    var diffDays = getDiffDays(startDate, endDate);
    return diffDays <= 90 ? '86400' : diffDays <= 730 ? '2592000' : '31104000';
};
var getDateRangeToShow = function (nextCustomRangeStartDate, timeRangeForCustomDate) {
    return "".concat(moment(nextCustomRangeStartDate).format('DD/MM/YY'), "-").concat(moment(nextCustomRangeStartDate)
        .clone()
        .add(timeRangeForCustomDate === '2592000' ? 30 : 365, 'days')
        .format('DD/MM/YY'));
};
export var generateTimeVariables = function (dateRangeSelectedValue, customRangeValue) {
    var startDate = moment().startOf('day').subtract(7, 'days').toISOString();
    var endDate = moment().endOf('day').toISOString();
    var timeRange = '86400';
    if (dateRangeSelectedValue.value === 'today') {
        startDate = moment().startOf('day').toISOString();
        endDate = moment().endOf('day').toISOString();
        timeRange = '14400';
    }
    if (dateRangeSelectedValue.value === 'last_14_days') {
        startDate = moment().startOf('day').subtract(14, 'days').toISOString();
        endDate = moment().endOf('day').toISOString();
        timeRange = '86400';
    }
    if (dateRangeSelectedValue.value === 'last_30_days') {
        startDate = moment().startOf('day').subtract(30, 'days').toISOString();
        endDate = moment().endOf('day').toISOString();
        timeRange = '86400';
    }
    if (dateRangeSelectedValue.value === 'custom_range') {
        startDate = moment(customRangeValue.startDate).startOf('day').toISOString();
        endDate = moment(customRangeValue.endDate).endOf('day').toISOString();
        timeRange = getTimeRangeForCustomDate(customRangeValue.startDate, customRangeValue.endDate);
    }
    return {
        startDate: startDate,
        endDate: endDate,
        timeRange: timeRange,
    };
};
export var generateDownloadsData = function (dateRangeSelectedValue, downloads, customRangeValue) {
    //custom_range
    var nextCustomRangeStartDate = customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate;
    var timeRangeForCustomDate = dateRangeSelectedValue.value === 'custom_range'
        ? getTimeRangeForCustomDate(customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate, customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.endDate)
        : null;
    var dateRangeToShow;
    //!custom_range
    var downloadsTotal = 0;
    var downloadsData = downloads === null || downloads === void 0 ? void 0 : downloads.sort(function (a, b) { return a.timestamp.localeCompare(b.timestamp); }).map(function (item) {
        var _a;
        var itemData = ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a[0]) || {};
        downloadsTotal +=
            ((itemData === null || itemData === void 0 ? void 0 : itemData.android) || 0) + ((itemData === null || itemData === void 0 ? void 0 : itemData.ios) || 0) + ((itemData === null || itemData === void 0 ? void 0 : itemData.web) || 0);
        if (dateRangeSelectedValue.value === 'custom_range') {
            dateRangeToShow = getDateRangeToShow(nextCustomRangeStartDate, timeRangeForCustomDate);
            nextCustomRangeStartDate = moment(nextCustomRangeStartDate)
                .clone()
                .add(timeRangeForCustomDate === '2592000' ? 31 : 366, 'days');
        }
        return {
            time: dateRangeSelectedValue.value === 'today'
                ? "".concat(moment(item === null || item === void 0 ? void 0 : item.timestamp).format('HH'), " h")
                : dateRangeSelectedValue.value === 'custom_range' &&
                    timeRangeForCustomDate !== '86400'
                    ? dateRangeToShow
                    : moment(item === null || item === void 0 ? void 0 : item.timestamp).format('MMM D'),
            android: itemData === null || itemData === void 0 ? void 0 : itemData.android,
            ios: itemData === null || itemData === void 0 ? void 0 : itemData.ios,
            web: itemData === null || itemData === void 0 ? void 0 : itemData.web,
        };
    });
    return { downloadsTotal: downloadsTotal, downloadsData: downloadsData };
};
export var generateNewUsersData = function (dateRangeSelectedValue, users, customRangeValue) {
    //custom_range
    var nextCustomRangeStartDate = customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate;
    var timeRangeForCustomDate = dateRangeSelectedValue.value === 'custom_range'
        ? getTimeRangeForCustomDate(customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate, customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.endDate)
        : null;
    var dateRangeToShow;
    //!custom_range
    var newUsersData = users === null || users === void 0 ? void 0 : users.sort(function (a, b) { return a.timestamp.localeCompare(b.timestamp); }).map(function (item) {
        var _a;
        var itemData = ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a[0]) || {};
        if (dateRangeSelectedValue.value === 'custom_range') {
            dateRangeToShow = getDateRangeToShow(nextCustomRangeStartDate, timeRangeForCustomDate);
            nextCustomRangeStartDate = moment(nextCustomRangeStartDate)
                .clone()
                .add(timeRangeForCustomDate === '2592000' ? 31 : 366, 'days');
        }
        return {
            time: dateRangeSelectedValue.value === 'today'
                ? "".concat(moment(item === null || item === void 0 ? void 0 : item.timestamp).format('HH'), " h")
                : dateRangeSelectedValue.value === 'custom_range' &&
                    timeRangeForCustomDate !== '86400'
                    ? dateRangeToShow
                    : moment(item === null || item === void 0 ? void 0 : item.timestamp).format('MMM D'),
            anonymous: itemData === null || itemData === void 0 ? void 0 : itemData.anonymous_count,
            registered: itemData === null || itemData === void 0 ? void 0 : itemData.registered_count,
        };
    });
    return newUsersData;
};
export var generateActiveUserData = function (dateRangeSelectedValue, platformSelectedValue, usage, customRangeValue) {
    //custom_range
    var nextCustomRangeStartDate = customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate;
    var timeRangeForCustomDate = dateRangeSelectedValue.value === 'custom_range'
        ? getTimeRangeForCustomDate(customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate, customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.endDate)
        : null;
    var dateRangeToShow;
    //!custom_range
    var activeUserData = usage === null || usage === void 0 ? void 0 : usage.sort(function (a, b) { return a.timestamp.localeCompare(b.timestamp); }).map(function (item) {
        var _a, _b, _c, _d, _e, _f, _g;
        var itemData = ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a[0]) || {};
        var totalSession = (((_b = itemData === null || itemData === void 0 ? void 0 : itemData.android) === null || _b === void 0 ? void 0 : _b.active_users) || 0) +
            (((_c = itemData === null || itemData === void 0 ? void 0 : itemData.ios) === null || _c === void 0 ? void 0 : _c.active_users) || 0) +
            (((_d = itemData === null || itemData === void 0 ? void 0 : itemData.web) === null || _d === void 0 ? void 0 : _d.active_users) || 0);
        if (dateRangeSelectedValue.value === 'custom_range') {
            dateRangeToShow = getDateRangeToShow(nextCustomRangeStartDate, timeRangeForCustomDate);
            nextCustomRangeStartDate = moment(nextCustomRangeStartDate)
                .clone()
                .add(timeRangeForCustomDate === '2592000' ? 31 : 366, 'days');
        }
        return {
            time: dateRangeSelectedValue.value === 'today'
                ? "".concat(moment(item === null || item === void 0 ? void 0 : item.timestamp).format('HH'), " h")
                : dateRangeSelectedValue.value === 'custom_range' &&
                    timeRangeForCustomDate !== '86400'
                    ? dateRangeToShow
                    : moment(item === null || item === void 0 ? void 0 : item.timestamp).format('MMM D'),
            val: platformSelectedValue.value === 'android'
                ? (_e = itemData === null || itemData === void 0 ? void 0 : itemData.android) === null || _e === void 0 ? void 0 : _e.active_users
                : platformSelectedValue.value === 'ios'
                    ? (_f = itemData === null || itemData === void 0 ? void 0 : itemData.ios) === null || _f === void 0 ? void 0 : _f.active_users
                    : platformSelectedValue.value === 'web'
                        ? (_g = itemData === null || itemData === void 0 ? void 0 : itemData.web) === null || _g === void 0 ? void 0 : _g.active_users
                        : totalSession,
        };
    });
    return activeUserData;
};
export var generateAverageTimeData = function (dateRangeSelectedValue, platformSelectedValue, usage, customRangeValue) {
    //custom_range
    var nextCustomRangeStartDate = customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate;
    var timeRangeForCustomDate = dateRangeSelectedValue.value === 'custom_range'
        ? getTimeRangeForCustomDate(customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.startDate, customRangeValue === null || customRangeValue === void 0 ? void 0 : customRangeValue.endDate)
        : null;
    var dateRangeToShow;
    //!custom_range
    var averageTimeData = usage === null || usage === void 0 ? void 0 : usage.sort(function (a, b) { return a.timestamp.localeCompare(b.timestamp); }).map(function (item) {
        var _a, _b, _c, _d, _e, _f, _g;
        var itemData = ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a[0]) || {};
        var averageTime = (((_b = itemData === null || itemData === void 0 ? void 0 : itemData.android) === null || _b === void 0 ? void 0 : _b.average_time) || 0) +
            (((_c = itemData === null || itemData === void 0 ? void 0 : itemData.ios) === null || _c === void 0 ? void 0 : _c.average_time) || 0) +
            (((_d = itemData === null || itemData === void 0 ? void 0 : itemData.web) === null || _d === void 0 ? void 0 : _d.average_time) || 0);
        if (dateRangeSelectedValue.value === 'custom_range') {
            dateRangeToShow = getDateRangeToShow(nextCustomRangeStartDate, timeRangeForCustomDate);
            nextCustomRangeStartDate = moment(nextCustomRangeStartDate)
                .clone()
                .add(timeRangeForCustomDate === '2592000' ? 31 : 366, 'days');
        }
        return {
            time: dateRangeSelectedValue.value === 'today'
                ? "".concat(moment(item === null || item === void 0 ? void 0 : item.timestamp).format('HH'), " h")
                : dateRangeSelectedValue.value === 'custom_range' &&
                    timeRangeForCustomDate !== '86400'
                    ? dateRangeToShow
                    : moment(item === null || item === void 0 ? void 0 : item.timestamp).format('MMM D'),
            val: platformSelectedValue.value === 'android'
                ? (_e = itemData === null || itemData === void 0 ? void 0 : itemData.android) === null || _e === void 0 ? void 0 : _e.average_time
                : platformSelectedValue.value === 'ios'
                    ? (_f = itemData === null || itemData === void 0 ? void 0 : itemData.ios) === null || _f === void 0 ? void 0 : _f.average_time
                    : platformSelectedValue.value === 'web'
                        ? (_g = itemData === null || itemData === void 0 ? void 0 : itemData.web) === null || _g === void 0 ? void 0 : _g.average_time
                        : averageTime,
        };
    });
    return averageTimeData;
};
var getBuildShortVersion = function (build) {
    var _a, _b;
    var bundleShortVersion = build ? "1.0.".concat(build.Build.build_number) : '';
    var version = (_b = (_a = build === null || build === void 0 ? void 0 : build.Build) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.bundle_short_version;
    if (version) {
        var iOSLastPatchVersion = version.patch;
        bundleShortVersion = "".concat(version === null || version === void 0 ? void 0 : version.major, ".").concat(version === null || version === void 0 ? void 0 : version.minor, ".").concat(iOSLastPatchVersion);
    }
    return bundleShortVersion;
};
export var getMajorMinorPatch = function (build) {
    var _a, _b, _c;
    var major = 1;
    var minor = 0;
    var patch = (_a = build === null || build === void 0 ? void 0 : build.Build) === null || _a === void 0 ? void 0 : _a.build_number;
    var version = (_c = (_b = build === null || build === void 0 ? void 0 : build.Build) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.bundle_short_version;
    if (version) {
        major = version === null || version === void 0 ? void 0 : version.major;
        minor = version === null || version === void 0 ? void 0 : version.minor;
        patch = version === null || version === void 0 ? void 0 : version.patch;
    }
    return { major: major, minor: minor, patch: patch };
};
export var getLastVersionDetails = function (builds) {
    var _a, _b;
    var sortedBuilds = (builds === null || builds === void 0 ? void 0 : builds.sort(function (a, b) {
        return b.Build.updated_at.localeCompare(a.Build.updated_at);
    })) || [];
    var iOSBuilds = [];
    var androidBuilds = [];
    sortedBuilds === null || sortedBuilds === void 0 ? void 0 : sortedBuilds.map(function (build) {
        return build.Build.platform === 'ios'
            ? iOSBuilds.push(build)
            : androidBuilds.push(build);
    });
    var iOSLastBuild = iOSBuilds === null || iOSBuilds === void 0 ? void 0 : iOSBuilds[0];
    var iOSLastBundleShortVersion = getBuildShortVersion(iOSLastBuild);
    var androidLastBuild = androidBuilds === null || androidBuilds === void 0 ? void 0 : androidBuilds[0];
    var androidLastBundleShortVersion = getBuildShortVersion(androidLastBuild);
    var iOSLastSuccessfulBuild = (_a = iOSBuilds.filter(function (build) { return build.Build.status === 'success'; })) === null || _a === void 0 ? void 0 : _a[0];
    var iOSLastSuccessfulBundleShortVersion = getBuildShortVersion(iOSLastSuccessfulBuild);
    var androidLastSuccessfulBuild = (_b = androidBuilds.filter(function (build) { return build.Build.status === 'success'; })) === null || _b === void 0 ? void 0 : _b[0];
    var androidLastSuccessfulBundleShortVersion = getBuildShortVersion(androidLastSuccessfulBuild);
    return {
        iOSLastBuild: iOSLastBuild,
        iOSLastBundleShortVersion: iOSLastBundleShortVersion,
        iOSLastSuccessfulBuild: iOSLastSuccessfulBuild,
        iOSLastSuccessfulBundleShortVersion: iOSLastSuccessfulBundleShortVersion,
        androidLastBuild: androidLastBuild,
        androidLastBundleShortVersion: androidLastBundleShortVersion,
        androidLastSuccessfulBuild: androidLastSuccessfulBuild,
        androidLastSuccessfulBundleShortVersion: androidLastSuccessfulBundleShortVersion,
    };
};
export var formatBigNumber = function (value) {
    return value > 10000 ? "".concat((value / 1000).toFixed(1), "k ") : value;
};
export var formatMilliSeconds = function (value) {
    return value === 'NaN'
        ? 0
        : value > 3600
            ? "".concat(Math.floor(value / 3600), "h ").concat(Math.floor((value % 3600) / 60), "m")
            : "".concat(Math.floor(value / 60), "m ").concat(Math.floor(value % 60), "s");
};
